module.exports = __webpack_public_path__ + "static/img/feature_2.5ae0c6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundamentals/feature_2.png
// module id = LNND
// module chunks = 0